/**
 * FERRE la Económica – Enhanced Search Panel
 * Búsquedas populares y categorías de ferretería al enfocar el input vacío.
 */
(function () {
  'use strict';

  const POPULAR_SEARCHES = [
    'Taladro Truper', 'Extensión eléctrica', 'Cerradura Pretul',
    'Llave de impacto', 'Milwaukee M18', 'Pintura vinílica'
  ];

  function loadCategories() {
    try {
      const el = document.getElementById('ferre-collection-data');
      if (el) return JSON.parse(el.textContent);
    } catch (e) { /* fall through */ }
    return [];
  }
  const CATEGORIES = loadCategories();

  const TREND_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>`;

  function buildPanel() {
    const chipsHtml = POPULAR_SEARCHES.map(s =>
      `<a class="jinsa-search-chip" href="/search?q=${encodeURIComponent(s)}">${TREND_SVG}${s}</a>`
    ).join('');

    const catsHtml = CATEGORIES.map(c => `
      <a class="jinsa-search-cat-item" href="/collections/${c.handle}">
        <span class="jinsa-search-cat-badge">${c.code}</span>
        <span>
          <div class="jinsa-search-cat-name">${c.name}</div>
          <div class="jinsa-search-cat-count">${c.count} productos</div>
        </span>
      </a>`
    ).join('');

    return `
      <div class="jinsa-search-panel-section">
        <div class="jinsa-search-panel-title">Búsquedas populares</div>
        <div class="jinsa-search-chips">${chipsHtml}</div>
      </div>
      ${catsHtml ? `
      <div class="jinsa-search-panel-divider"></div>
      <div class="jinsa-search-panel-section">
        <div class="jinsa-search-panel-title">Explorar departamentos</div>
        <div class="jinsa-search-categories">${catsHtml}</div>
      </div>` : ''}`;
  }

  function attachPanel(fieldEl) {
    if (fieldEl.dataset.ferreEnhanced) return;
    fieldEl.dataset.ferreEnhanced = '1';

    const panel = document.createElement('div');
    panel.className = 'jinsa-search-panel';
    panel.setAttribute('role', 'listbox');
    panel.innerHTML = buildPanel();

    fieldEl.style.position = 'relative';
    fieldEl.appendChild(panel);

    const input = fieldEl.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;

    let focusTimeout;
    const show = () => { if (!(input.value || '').trim()) panel.classList.add('open'); };
    const hide = () => { clearTimeout(focusTimeout); focusTimeout = setTimeout(() => panel.classList.remove('open'), 180); };

    input.addEventListener('focus', show);
    input.addEventListener('input', () => {
      (input.value || '').trim() ? panel.classList.remove('open') : show();
    });
    input.addEventListener('blur', hide);
    panel.addEventListener('mousedown', e => e.preventDefault());
    panel.addEventListener('click', () => panel.classList.remove('open'));
  }

  function init() {
    document.querySelectorAll('.header__search .field').forEach(attachPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
